import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";
import { useNavigate } from "react-router-dom";

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Firebase Auth
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../App";

//Social Media Imports
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { socialLogin } from "../../store/actions";

//Import config
import { facebook } from "../../config";

import { createSelector } from "reselect";
import Axios from "../../lib/Axios";
import useUserAuthStore from "../../zStore/userAuth";
// import { APIClient } from "../../helpers/api_helper";
import ToastHandler from "../../components/Common/ToastHandler";

const Login = (props) => {
  document.title = "Login | Upzet - React Admin & Dashboard Template";
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { setUserData } = useUserAuthStore();
  const [toastData, setToastData] = useState({
    message: "",
    title: "",
  });

  const [toast, setToast] = useState(false);

  // function toggleToast() {
  //   console.log("toast");
  //   setToastData((prev) => ({ ...prev, open: !prev.open }));
  // }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: login,
  });

  async function login(value) {
    try {
      const resp = await Axios.post("/auth/login", {
        username_email: value.email,
        password: value.password,
      });
      
      // Validate userType before proceeding
      // Check both possible response structures
      const userData = resp.data.result.results || resp.data.result.user;
      const token = resp.data.result.data;
      
      const userType = userData?.userType || userData?.user_type;
      
      // Convert to number and check (handles both string "1" and number 1)
      if (Number(userType) !== 1) {
        setToastData({
          message: "Unauthorized. You do not have permission to access this application.",
          title: "Unauthorized",
        });
        setToast(true);
        return; // Don't proceed with login
      }
      
      // Store user data with token if available
      const dataToStore = token ? { ...userData, data: token } : userData;
      setUserData(dataToStore);
      navigate("/school");
      // dispatch(loginUser(resp.data.result.results, props.router.navigate));
    } catch (error) {
      setToastData({
        message: error.response.data.error.message,
        title: "Error",
      });
      setToast(true);
    }
  }

  const loginpage = createSelector(
    (state) => state.login,
    (state) => ({
      error: state.error,
    })
  );
  // Inside your component
  const { error } = useSelector(loginpage);

  // handleValidSubmit
  // const handleValidSubmit = (event, values) => {
  //   dispatch(loginUser(values, props.router.navigate));
  // };

  //handleGoogleLoginResponse - Now using Firebase Auth
  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      // Send idToken to your backend
      const resp = await Axios.post("/auth/oauth2/google/cms-login", {
        token: idToken,
      });
      
      // Validate userType before proceeding
      // The user object is in resp.data.result.user, token is in resp.data.result.data
      const user = resp.data.result.user;
      const token = resp.data.result.data;
      
      const userType = user?.userType || user?.user_type;
      
      // Convert to number and check (handles both string "1" and number 1)
      if (Number(userType) !== 1) {
        setToastData({
          message: "Unauthorized. You do not have permission to access this application.",
          title: "Unauthorized",
        });
        setToast(true);
        return; // Don't proceed with login
      }
      
      // Store user data with token (matching the expected structure)
      setUserData({ ...user, data: token });
      navigate("/school");
    } catch (error) {
      console.error("Google login error:", error);
      setToastData({
        message: error.response?.data?.error?.message || error.message || "Google login failed",
        title: "Error",
      });
      setToast(true);
    }
  };

  const signIn = (res, type) => {
    // Google login is now handled directly in googleResponse
    if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    }
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = (response) => {
    signIn(response, "facebook");
  };

  useEffect(() => {
    document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });

  return (
    <>
      <React.Fragment>
        <div className="bg-overlay"></div>

        <div className="account-pages my-5 pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card>
                  <CardBody className="p-4">
                    <div>
                      <div className="text-center">
                        <Link to="/">
                          <img
                            src={logodark}
                            alt=""
                            height="24"
                            className="auth-logo logo-dark mx-auto"
                          />
                          <img
                            src={logolight}
                            alt=""
                            height="24"
                            className="auth-logo logo-light mx-auto"
                          />
                        </Link>
                      </div>
                      <h4 className="font-size-18 text-muted mt-2 text-center">
                        Welcome Back !
                      </h4>
                      <p className="mb-5 text-center">
                        Sign in to continue to Upzet.
                      </p>
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        {error ? (
                          <Alert color="danger">
                            <div>{error}</div>
                          </Alert>
                        ) : null}
                        <Row>
                          <Col md={12}>
                            <div className="mb-4">
                              <Label className="form-label">Email</Label>
                              <Input
                                name="email"
                                className="form-control"
                                placeholder="Enter email"
                                type="email"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                              validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.email}</div>
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-4">
                              <Label className="form-label">Password</Label>
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type="password"
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password &&
                                  validation.errors.password
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.password &&
                              validation.errors.password ? (
                                <FormFeedback type="invalid">
                                  <div> {validation.errors.password} </div>
                                </FormFeedback>
                              ) : null}
                            </div>

                            <Row>
                              <Col>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customControlInline"
                                  />
                                  <label
                                    className="form-label form-check-label"
                                    htmlFor="customControlInline"
                                  >
                                    Remember me
                                  </label>
                                </div>
                              </Col>
                              <Col className="col-7">
                                <div className="text-md-end mt-3 mt-md-0">
                                  <Link
                                    to="/auth-recoverpw"
                                    className="text-muted"
                                  >
                                    <i className="mdi mdi-lock"></i> Forgot your
                                    password?
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <div className="d-grid mt-4">
                              <button
                                className="btn btn-primary waves-effect waves-light"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>
                            <div className="mt-4 text-center">
                              <h5 className="font-size-14 mb-3">
                                Sign in with
                              </h5>

                              <ul className="list-inline">
                                <li className="list-inline-item">
                                  <FacebookLogin
                                    appId={facebook.APP_ID}
                                    autoLoad={false}
                                    callback={facebookResponse}
                                    render={(renderProps) => (
                                      <Link
                                        to="#"
                                        className="social-list-item bg-primary text-white border-primary"
                                        onClick={renderProps.onClick}
                                      >
                                        <i className="mdi mdi-facebook" />
                                      </Link>
                                    )}
                                  />
                                </li>

                                <li className="list-inline-item">
                                  <Link
                                    to="#"
                                    className="social-list-item bg-danger text-white border-danger"
                                    onClick={handleGoogleLogin}
                                  >
                                    <i className="mdi mdi-google" />
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p className="text-white-50">
                    Don't have an account ?{" "}
                    <Link to="/register" className="fw-medium text-primary">
                      {" "}
                      Register{" "}
                    </Link>{" "}
                  </p>
                  <p className="text-white-50">
                    © {new Date().getFullYear()} Upzet. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger"></i> by
                    Themesdesign
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <ToastHandler
          open={toast}
          setOpen={setToast}
          duration={2000}
          message={toastData.message}
          title={toastData.title}
        />
      </React.Fragment>
    </>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
